import { render, staticRenderFns } from "./UI.vue?vue&type=template&id=214efc27&"
import script from "./UI.vue?vue&type=script&lang=js&"
export * from "./UI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports